import {
  Ban,
  LifeBuoy,
  type LucideIcon,
  MessageSquareText,
  Plug,
  ShieldCheck,
  Wrench,
} from "lucide-react";
import type { ComponentType } from "react";

import type { DocPageId } from "@/lib/docs-pages";

import { AskPage } from "./ask-page";
import { ConnectPage } from "./connect-page";
import { LIMIT_IDS, PRIVACY_IDS, useDocsContent } from "./content";
import { EntryList, FaqList } from "./doc-parts";
import { RoleTable } from "./role-table";
import { ToolListPage } from "./tool-list-page";

interface DocPageParts {
  /** Beside the page's title in the docs' navigation. */
  icon: LucideIcon;
  /** What the page shows under its title. */
  Body: ComponentType;
}

/** Each page of the docs: its icon and its content. The order is `DOC_PAGES`'. */
export const DOC_PAGE_PARTS: Record<DocPageId, DocPageParts> = {
  "connect-claude": { icon: Plug, Body: ConnectPage },
  "what-you-can-ask": { icon: MessageSquareText, Body: AskPage },
  tools: { icon: Wrench, Body: ToolListPage },
  limits: { icon: Ban, Body: LimitsPage },
  "privacy-and-data": { icon: ShieldCheck, Body: PrivacyPage },
  troubleshooting: { icon: LifeBuoy, Body: TroubleshootingPage },
};

/** What the connector cannot do or see. */
function LimitsPage() {
  const { limits } = useDocsContent();
  return <EntryList ids={LIMIT_IDS} entries={limits} />;
}

/** What happens to the data, then who sees what on the dashboard, per role. */
function PrivacyPage() {
  const { privacy } = useDocsContent();
  return (
    <>
      <EntryList ids={PRIVACY_IDS} entries={privacy} />
      <RoleTable />
    </>
  );
}

/** Answers to frequent questions and problems, each opening on its own. */
function TroubleshootingPage() {
  const { faq } = useDocsContent();
  return <FaqList entries={faq} />;
}
